export const HIERARCHY_SHIPPING_MODES = {
  SINGLE: 'SINGLE',
  BULK: 'BULK',
};

export const HIERARCHY_SHIPPING_BULK_ORDER_SORTS = {
  CREATED_AT_DESC: 'CREATED_AT_DESC',
  CREATED_AT_ASC: 'CREATED_AT_ASC',
  FIRST_NAME_ASC: 'FIRST_NAME_ASC',
  LAST_NAME_ASC: 'LAST_NAME_ASC',
};

export const DEFAULT_HIERARCHY_SHIPPING_BULK_ORDER_SORT =
  HIERARCHY_SHIPPING_BULK_ORDER_SORTS.CREATED_AT_DESC;

export const HIERARCHY_SHIPPING_BULK_ORDER_SORT_LABELS = {
  [HIERARCHY_SHIPPING_BULK_ORDER_SORTS.CREATED_AT_DESC]:
    'Creation Time (Latest first)',
  [HIERARCHY_SHIPPING_BULK_ORDER_SORTS.CREATED_AT_ASC]:
    'Creation Time (Oldest first)',
  [HIERARCHY_SHIPPING_BULK_ORDER_SORTS.FIRST_NAME_ASC]: 'First Name (A-Z)',
  [HIERARCHY_SHIPPING_BULK_ORDER_SORTS.LAST_NAME_ASC]: 'Last Name (A-Z)',
};
